var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0C4.704 0 0 4.704 0 10.5C0 16.296 4.704 21 10.5 21C16.296 21 21 16.296 21 10.5C21 4.704 16.296 0 10.5 0ZM10.5511 15.9879C10.0011 15.9879 9.55105 15.4629 9.55105 14.8212V10.1545C9.55105 9.51288 10.0011 8.98788 10.5511 8.98788C11.1011 8.98788 11.5511 9.51288 11.5511 10.1545V14.8212C11.5511 15.4629 11.1011 15.9879 10.5511 15.9879ZM10.5445 7.77244C11.0967 7.77244 11.5445 7.32473 11.5445 6.77244C11.5445 6.22016 11.0967 5.77245 10.5445 5.77245C9.99218 5.77245 9.54446 6.22016 9.54446 6.77244C9.54446 7.32473 9.99218 7.77244 10.5445 7.77244Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.94dc111941d3588393f299b91f182b57.svg";